import './lib/bootstrap-rating-input/bootstrap-rating-input.min';


sproductreviews.script = (function () {
    var $productReviewForm = $('#sproductreviews-productreview-form');

    return {
        'init': function () {

            if (sthemeTheme.pp_tabs == 'tabh' || sthemeTheme.pp_tabs == 'tabha') {

                $('#sproductreviews-rating-product').on('click', function () {
                    let element = document.getElementById("product-infos-tabs");
                    $('.nav-tabs a[data-studioextra="nav-link-studio-reviews-tab"]').tab('show');

                    if(typeof(element) != 'undefined' && element != null){
                        element.scrollIntoView();
                    }

                });
            } else{

                $('#sproductreviews-rating-product').on('click', function () {
                    document.getElementById("studio-reviews-tab").scrollIntoView();
                });
            }

            $productReviewForm.submit(function(e) {

                e.preventDefault();

                var $productReviewFormAlert = $('#sproductreviews-productreview-form-alert'),
                    $productReviewFormSuccessAlert = $('#sproductreviews-productreview-form-success-alert');


                $.post($(this).attr('action'), $(this).serialize(), null, 'json').then(function (resp) {

                    if (!resp.success){
                        let htmlResp = '<strong>' + resp.data.message + '</strong>';

                        htmlResp = htmlResp + '<ul>';
                        $.each(resp.data.errors, function( index, value ) {
                            htmlResp = htmlResp + '<li>' + value + '</li>';
                        });
                        htmlResp = htmlResp + '</ul>';

                        $productReviewFormAlert.html(htmlResp);
                        $productReviewFormAlert.removeClass('hidden-xs-up');
                    } else {
                        let htmlResp = '<strong>' + resp.data.message + '</strong>';
                        $productReviewFormSuccessAlert.html(htmlResp);
                        $productReviewFormSuccessAlert.removeClass('hidden-xs-up');
                        $('#studio-reviews-modal').modal('hide');
                    }

                }).fail((resp) => {
                    $productReviewFormAlert.html(resp);
                    $productReviewFormAlert.removeClass('invisible');
                });

                e.preventDefault();

            });


        },
    };
})();

$(document).ready(() => {
        sproductreviews.script.init();
});





// WEBPACK FOOTER //
// ./front/front.js